
import React from 'react';
import type { Word } from '@/lib/game-utils';

interface SimpleWordListProps {
  words: Array<Word | string>;
}

export function SimpleWordList({ words }: SimpleWordListProps) {
  return (
    <>
      {words.map((word, index) => (
        <div key={`word-${index}`} className="bg-gray-100 p-3 rounded text-center mb-2">
          {String(word)}
        </div>
      ))}
    </>
  );
}
